const GUID = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
const AWS_ACCESS_KEY_ID = /^(AKIA|ASIA)[0-9A-Z]{16}$/;
// Snowflake: orgname-account_name, con o sin region (orgname-account.region).
const SNOWFLAKE_ACCOUNT = /^[a-z0-9]([a-z0-9-]*[a-z0-9])?(\.[a-z0-9]([a-z0-9-]*[a-z0-9])?)*$/i;

const trim = (value) => (typeof value === "string" ? value.trim() : "");

const required = (value, label) => (trim(value) ? null : `${label} is required`);

export const validators = {
  none: () => null,

  nonEmpty: (value, label) => required(value, label),

  guid: (value, label) => {
    const missing = required(value, label);
    if (missing) return missing;
    return GUID.test(trim(value)) ? null : `${label} must be a 36-character GUID`;
  },

  awsAccessKeyId: (value, label) => {
    const missing = required(value, label);
    if (missing) return missing;
    return AWS_ACCESS_KEY_ID.test(trim(value))
      ? null
      : `${label} must look like AKIA... (20 characters)`;
  },

  snowflakeAccount: (value, label) => {
    const missing = required(value, label);
    if (missing) return missing;
    return SNOWFLAKE_ACCOUNT.test(trim(value))
      ? null
      : `${label} must look like myorg-myaccount (optionally with a region)`;
  },

  json: (value, label) => {
    const missing = required(value, label);
    if (missing) return missing;
    try {
      JSON.parse(trim(value));
      return null;
    } catch (error) {
      return `${label} must be valid JSON`;
    }
  },
};

export const validateField = (field, value) => {
  const validate = validators[field.validate] || validators.none;
  return validate(value, field.label);
};

export const isGuid = (value) => GUID.test(trim(value));
